import { FormattedMessage } from "react-intl";
import OcrPage from "./sidebar/digitalAITool/ocrPage/ocrPage";
// eslint-disable-next-line import/no-cycle
import AiPage from "./sidebar/digitalAITool/aiPage/AiPage";
import AjiPage from "./sidebar/digitalAITool/ajiPage/AjiPage";

export const SnaWAConfig = {
  content: [
    {
      name: "group",
      subPage: false,
      // component: Main,
    },
    {
      name: "file",
      subPage: false,
      // component: Main,
    },
    {
      name: "digitalAI",
      subPage: true,
    },
    {
      name: "adjust",
      subPage: false,
      // component: Main,
    },
    {
      name: "filter",
      subPage: false,
      // component: Main,
    },
    {
      name: "analytics",
      subPage: false,
      // component: Main,
    },
    {
      name: "evnCtgSetting",
      subPage: false,
      // component: Main,
    },
  ],
};

export const subConfig = {
  // digitalAI page
  digitalAI: {
    content: [
      {
        name: "ocr",
        label: (
          <FormattedMessage
            id="sna.sidetool.digitalAITool.ocr.title"
            defaultMessage="OCR 文字辨識"
          />
        ),
        component: OcrPage,
      },
      {
        name: "ai",
        label: (
          <FormattedMessage
            id="sna.sidetool.digitalAITool.ai.title"
            defaultMessage="AI 語意分析"
          />
        ),
        component: AiPage,
      },
      {
        name: "aji",
        label: (
          <FormattedMessage
            id="sna.sidetool.digitalAITool.aji.title"
            defaultMessage="阿記"
          />
        ),
        component: AjiPage,
      },
    ],
  },
};
